module.exports = __webpack_public_path__ + "img/body-map.4ca2b7da.png";